import { ILayoutColors } from './layout.meta.model'

export class ResetLayoutStateAction {
  public static readonly type = '[LayoutMeta] Reset to Initial State'
  constructor() {}
}

export class SetColorsAction {
  public static readonly type = '[LayoutMeta] Set Colors'
  constructor(public payload: ILayoutColors) {}
}

export class SetLanguageAction {
  public static readonly type = '[LayoutMeta] Set Language'
  constructor(public payload: string) {}
}

export class ToggleSidebarAction {
  public static readonly type = '[LayoutMeta] Toggle Sidebar'
  constructor() {}
}
